import { M8DemoStackDTO } from 'services/production/types';
import { DemoStackInfo } from 'types/state';
import { createDemoStackInfo } from 'utils/demoStackInfoUtils';

export const normalizeM8DemoStackDTO = (m8DemoStackDTO: M8DemoStackDTO) => ({
  toDemoStackInfo(): DemoStackInfo {
    let demoStackInfo = createDemoStackInfo();

    demoStackInfo.id = m8DemoStackDTO.id;
    demoStackInfo.originURL = m8DemoStackDTO.url;
    demoStackInfo.subdomain = m8DemoStackDTO.dnsName;

    return demoStackInfo;
  },
});
